var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.css.error] = true, _obj[_vm.css[_vm.theme]] = true, _obj )},[_c('Error',{attrs:{"theme":_vm.theme,"type":_vm.isOffline || _vm.isReloading ? 'noConnection' : '404'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }